import React from 'react';
import styled from 'styled-components';

const UsersListSkeleton = () => {
    return (
        <Container>
            <HeaderSkeleton>
                <TitlePlaceholder />
                <ButtonPlaceholder />
            </HeaderSkeleton>
            <TableSkeleton>
                <TableHeader />
                {Array.from({ length: 8 }).map((_, i) => (
                    <TableRow key={i} />
                ))}
            </TableSkeleton>
        </Container>
    );
};

export default UsersListSkeleton;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

const HeaderSkeleton = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
`;

const TitlePlaceholder = styled.div`
    height: 32px;
    width: 200px;
    background: #e0e0e0;
    border-radius: 6px;
    animation: pulse 1.5s infinite ease-in-out;
`;

const ButtonPlaceholder = styled.div`
    height: 40px;
    width: 120px;
    background: #e0e0e0;
    border-radius: 8px;
    animation: pulse 1.5s infinite ease-in-out;
`;

const TableSkeleton = styled.div`
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;
    overflow: hidden;
    padding: 1rem;
`;

const TableHeader = styled.div`
    height: 48px;
    background: #f9fafb;
    border-radius: 8px;
    margin-bottom: 0.75rem;
    animation: pulse 1.5s infinite ease-in-out;
`;

const TableRow = styled.div`
    height: 64px;
    border-bottom: 1px solid #f3f4f6;
    margin-bottom: 0.5rem;
    background: #ffffff;
    border-radius: 6px;
    animation: pulse 1.5s infinite ease-in-out;

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }

    @keyframes pulse {
        0% { opacity: 0.6; }
        50% { opacity: 1; }
        100% { opacity: 0.6; }
    }
`;
